import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DIMENSIONS_DATA_WATCHER, GET_MEASURE_ENGAGEMENT_WATCHER } from "./constants"

import {
  getDimensionsDataFailed,
  getDimensionsDataSuccess,
  getMeasureEngagementFailed,
  getMeasureEngagementSuccess,
} from "./actions"
import { getDimensionsApi, getMeasureEngagementReportApi } from "../../../utils/routes/routes-report"

export function* getMeasureEngagementSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: resultTotal } = yield call(
      getMeasureEngagementReportApi,
      dataStatus.params
    )
    yield put(getMeasureEngagementSuccess(resultTotal))
  } catch (e) {
    yield put(getMeasureEngagementFailed())
  }
}

export function* getDimensionsDataSaga(action) {
  try {
    const dataStatus = action.payload
    const data = yield call(getDimensionsApi, dataStatus.params)
    yield put(getDimensionsDataSuccess(data))
  } catch (e) {
    yield put(getDimensionsDataFailed())
  }
}

export default function* engagementMeasurementSaga() {
  yield takeLatest(GET_DIMENSIONS_DATA_WATCHER, getDimensionsDataSaga)
  yield takeLatest(GET_MEASURE_ENGAGEMENT_WATCHER, getMeasureEngagementSaga)
}
